import React from "react";

interface TableSkeletonLoaderProps {
    rows?: number;
    cols?: number;
}

export const TableSkeletonLoader: React.FC<TableSkeletonLoaderProps> = ({ rows = 8, cols = 6 }) => {
    // Column width configuration for realistic appearance
    const getColumnWidth = (colIdx: number) => {
        if (colIdx === 0) return '60px';  // Rank column
        if (colIdx === 1) return '200px'; // Name column (wider)
        return '120px'; // Other columns
    };

    const getSkeletonWidth = (colIdx: number) => {
        if (colIdx === 0) return '30px';
        if (colIdx === 1) return '140px';
        return '80px';
    };

    return (
        <div className="h-100 w-100" style={{ overflow: 'hidden' }}>
            <table className="w-100 h-100" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                <thead>
                    <tr>
                        {[...Array(cols)].map((_, idx) => (
                            <th
                                key={idx}
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    backgroundColor: '#F8F8F8',
                                    padding: '12px 16px',
                                    textAlign: 'left',
                                    width: getColumnWidth(idx),
                                    borderBottom: '1px solid #EAEAEA',
                                }}
                            >
                                <div
                                    className="skeleton-shimmer"
                                    style={{
                                        height: '14px',
                                        width: getSkeletonWidth(idx),
                                        borderRadius: '4px',
                                    }}
                                />
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[...Array(rows)].map((_, rowIdx) => (
                        <tr key={rowIdx}>
                            {[...Array(cols)].map((_, colIdx) => (
                                <td
                                    key={colIdx}
                                    style={{
                                        padding: '14px 16px',
                                        borderBottom: '1px solid #F5F5F5',
                                        backgroundColor: '#FFFFFF',
                                    }}
                                >
                                    <div
                                        className="skeleton-shimmer"
                                        style={{
                                            height: '12px',
                                            width: colIdx === 1
                                                ? `${100 - (rowIdx % 3) * 15}px`
                                                : getSkeletonWidth(colIdx),
                                            borderRadius: '4px',
                                        }}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            <style>{`
                .skeleton-shimmer {
                    background: linear-gradient(
                        90deg,
                        #EFEFEF 0%,
                        #F8F8F8 50%,
                        #EFEFEF 100%
                    );
                    background-size: 200% 100%;
                    animation: shimmer 1.5s ease-in-out infinite;
                }

                @keyframes shimmer {
                    0% {
                        background-position: 200% 0;
                    }
                    100% {
                        background-position: -200% 0;
                    }
                }
            `}</style>
        </div>
    );
};
